type PaginationProps = {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
};

const Pagination = ({ currentPage, totalPages, onPageChange }: PaginationProps) => {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <nav className="mt-10 flex items-center justify-center gap-1.5" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md border border-background-300 px-3 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <span className="flex h-3.5 w-3.5 items-center justify-center">
          <i className="ri-arrow-left-s-line" />
        </span>
        上一页
      </button>
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onPageChange(page)}
          className={`h-9 w-9 cursor-pointer rounded-md text-xs font-medium transition-colors ${
            page === currentPage
              ? "bg-primary-500 text-background-50"
              : "border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
          }`}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md border border-background-300 px-3 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <span className="flex h-3.5 w-3.5 items-center justify-center">
          <i className="ri-arrow-right-s-line" />
        </span>
      </button>
    </nav>
  );
};

export default Pagination;